import { defineMessages } from 'react-intl';

export default defineMessages({
  errorHeader: {
    id: 'app.components.ErrorPage.errorHeader',
    defaultMessage: 'Oops, ocorreu um erro',
  },
  errorDescription: {
    id: 'app.components.ErrorPage.errorDescription',
    defaultMessage: 'Tente novamente mais tarde',
  },
  errorNotFoundHeader: {
    id: 'app.components.ErrorPage.errorNotFoundHeader',
    defaultMessage: 'Eita!',
  },
  errorNotFoundDescription: {
    id: 'app.components.ErrorPage.errorNotFoundDescription',
    defaultMessage: 'Não encontramos a página que você está procurando.',
  },
  errorNotFoundLinks: {
    id: 'app.components.ErrorPage.errorNotFoundLinks',
    defaultMessage: 'Aqui estão alguns links para informações que podem ser úteis:',
  },
  errorNotFoundFindAndRent: {
    id: 'app.components.ErrorPage.errorNotFoundFindAndRent',
    defaultMessage: 'Encontre e alugue sua próxima casa',
  },
  errorNotFoundFindAndRentLabel: {
    id: 'app.components.ErrorPage.errorNotFoundFindAndRentLabel',
    defaultMessage: 'Link de redirecionamento para a página principal do {companyName}',
  },
  errorNotFoundFindAndRentLink: {
    id: 'app.components.ErrorPage.errorNotFoundFindAndRentLink',
    defaultMessage: 'https://quintoandar.com.br',
  },
  errorNotFoundPublish: {
    id: 'app.components.ErrorPage.errorNotFoundPublish',
    defaultMessage: 'Anucie seu Imóvel',
  },
  errorNotFoundPublishLabel: {
    id: 'app.components.ErrorPage.errorNotFoundPublishLabel',
    defaultMessage: 'Link de redirecionamento para a página de anuncio de imvóvel',
  },
  errorNotFoundPublishLink: {
    id: 'app.components.ErrorPage.errorNotFoundPublishLink',
    defaultMessage: 'https://proprietario.quintoandar.com.br/anunciar-imovel',
  },
  errorNotFoundRecommend: {
    id: 'app.components.ErrorPage.errorNotFoundRecommend',
    defaultMessage: 'Indique imóveis para Alugar',
  },
  errorNotFoundRecommendLabel: {
    id: 'app.components.ErrorPage.errorNotFoundRecommendLabel',
    defaultMessage: 'Link de redirecionamento para a página de indicação de imóvel',
  },
  errorNotFoundRecommendLink: {
    id: 'app.components.ErrorPage.errorNotFoundRecommendLink',
    defaultMessage: 'https://indicaai.quintoandar.com.br',
  },
  errorNotFoundRealtor: {
    id: 'app.components.ErrorPage.errorNotFoundRealtor',
    defaultMessage: 'Seja um Corretor de imóveis',
  },
  errorNotFoundRealtorLabel: {
    id: 'app.components.ErrorPage.errorNotFoundRealtorLabel',
    defaultMessage: 'Link de redirecionamento para a página de corretores',
  },
  errorNotFoundRealtorLink: {
    id: 'app.components.ErrorPage.errorNotFoundRealtorLink',
    defaultMessage: 'https://mkt.quintoandar.com.br/corretor/',
  },
  errorNotFoundAbout: {
    id: 'app.components.ErrorPage.errorNotFoundAbout',
    defaultMessage: 'Sobre o {companyName}',
  },
  errorNotFoundAboutLabel: {
    id: 'app.components.ErrorPage.errorNotFoundAboutLabel',
    defaultMessage: 'Link de redirecionamento para a página de informações gerais '
      + 'sobre o {companyName}',
  },
  errorNotFoundAboutLink: {
    id: 'app.components.ErrorPage.errorNotFoundAboutLink',
    defaultMessage: 'https://press.quintoandar.com.br',
  },
});
